module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chap_title",
    attrs: {
      "id": "c05"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _vm._v("c. 7000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")])]), _vm._v(" "), _c('h2', {
    staticClass: "section1"
  }, [_vm._v("Rice Cultivation "), _c('span', {
    staticClass: "gray1"
  }, [_vm._v("• "), _c('em', [_vm._v("Michael C. Gerald with Gloria E. Gerald")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FEEDING ASIA.")]), _vm._v(" Rice is among the oldest and world’s most important economic botanical food crop. It is the largest source of calories for the 3.3 billion people of Asia, providing 35–80 percent of their total caloric intake. But, while rice is nutritious, it is not sufficient to serve as the main food source. The worldwide popularity of rice as a food is attributed, in part, to its ability to be grown in areas as varied as flooded plains to deserts and in all continents, except Antarctica. China and India are the major rice-producing and consuming countries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some 12,000–16,000 years ago, rice grains were initially gathered and consumed by prehistoric people in the world’s humid tropical and subtropical regions. Wild cultivated prototypes of rice, which descended from wild grasses, are members of the taxon family "), _c('em', [_vm._v("Poaceae")]), _vm._v(" (also called "), _c('em', [_vm._v("Gramineae")]), _vm._v("). Based on genetic evidence, recent reports reveal that rice cultivation first occurred in China between 8,200 and 13,500 years ago. From China, cultivation spread to India, then to western Asia and Greece, brought by the armies of Alexander the Great in 300 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v(". The most popular cultivated rices are "), _c('em', [_vm._v("Oryza satliva japonica")]), _vm._v(" (Asian rice and, by far, the most common) and "), _c('em', [_vm._v("Oryza glaberrima indica")]), _vm._v(" (African rice), both of which were domesticated from a common origin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The rice plants have an outer coating that protects the rice grain, the fruit of the plant. Seeds are milled to remove the chaff (outer husk) to produce brown rice. If milling is continued, and the rest of the husk and grain removed, white rice is left. Brown rice is more nutritious, containing proteins, minerals, and thiamine (vitamin B"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("), while white rice mainly contains carbohydrates and is virtually devoid of thiamine. Beriberi results from a nutritional deficiency in thiamine, which has been historically endemic in Asian populations, who favor polished white rice because it has a longer shelf life and is not historically associated with poverty. Among cereals, rice is low in sodium and fat, and free of cholesterol, making it a healthy food choice.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c02_r1#c02"
    }
  }, [_vm._v("Wheat: The Staff of Life (c. 11,000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v(")")]), _vm._v(", "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c03_r1#c03"
    }
  }, [_vm._v("Agriculture (c. 10,000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v(")")]), _vm._v(" "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c65_r1#c65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Artificial Selection (Selective Breeding) (1760)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Rice is the world’s most important food crop and provides the greatest proportion of calories to the people of Asia. Although this crop is typically grown on flooded plains, such as this one in Thailand, it can also be cultivated in deserts.Recent evidence suggests that rice may have actually been domesticated independently on three continents: Asia, Africa, and South America.")])]), _vm._v(" "), _c('div', {
    staticClass: "title1"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "id": "page21_1",
      "src": "Images/21-1.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b67aacd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454933007_epub_c05_r1.vue
// module id = 84
// module chunks = 0